export default "__VITE_ASSET__HaOcw5FI__"